<template>
    <router-link :to="link" class="grow no-underline mr3 pointer formLabel white" >
        <a><slot></slot></a>
    </router-link>
</template>

<script>
export default {
    props: {
        link: {
            type: String
        }
    }
};
</script>
